import Swiper from "swiper";
import { Pagination, Autoplay, FreeMode } from "swiper/modules";

/**
 * QueryLoopSlider
 * Initialize slider for query loop block
 * @since 1.0.0
 * @version 1.0.0
 * @return {void}
 * @constructor
 * @param {void}
 */
export default class QueryLoopSlider {
    constructor() {
        this.sliderOptions = {
            modules: [Pagination, Autoplay],
            loop: true,
            slidesPerView: "auto",
            spaceBetween: 30,
            createElements: true,
            centeredSlides: "auto",
            autoplay: true,
            pagination: {
                enabled: true,
            },
        };

        const sliderContainers = document.querySelectorAll(".is-style-slider");

        sliderContainers.forEach((sliderContainer) => {
            this.initSlider(sliderContainer);
        });
    }

    initSlider(sliderContainer) {
        const slider = sliderContainer.querySelector("ul");

        if (slider) {
            const slides = slider.querySelectorAll("li");
            slides.forEach((slide) => {
                slide.classList.add("swiper-slide");
            });
        }

        new Swiper(slider, this.sliderOptions);
    }
}
